import { of as observableOf, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, Auth, LoginResponse, UserAuthData } from '../../data/system/auth';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthService extends Auth {

  constructor(private http: HttpClient) {
    super();
  }

  user(username: string, password: string): Observable<LoginResponse> {
    const host = `${env.host}${env.endpoint.auth_login}`;
    return this.http.post<LoginResponse>(host, { mem_user_name: username, mem_password: password }).pipe(
      tap(data => console.log(`auth->user->data`, data))
    );
  }

  logout(): Observable<any> {
    const host = `${env.host}${env.endpoint.auth_logout}`;
    return this.http.post<ApiResponse>(host, {}).pipe(
      tap(data => console.log(`auth->destroy->data`, data))
    );
  }

  getSession(): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.auth_get_session}`;
    return this.http.post<ApiResponse>(host, {}).pipe();
  }

  getNewSession(): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.auth_renew}`;
    return this.http.post<ApiResponse>(host, {}).pipe();
  }

  authUser(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.auth_user.replace(':token', params.token).replace(':id', params.id)}`;
    return this.http.get<ApiResponse>(host).pipe();
  }

  authUserSecurity(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.auth_user_security}`;
    return this.http.post<ApiResponse>(host, { token: params.token, id: params.id, security: params.security }).pipe();
  }

}
